module.exports = __webpack_public_path__ + "img/Idanto.e60667ca.jpg";